import {Component, inject, OnInit} from '@angular/core';
import { AdminService } from '../admin/services/admin.service';
import { RoleService } from '../role/role.service';

@Component({
    selector: 'app-crm',
    templateUrl: './crm.component.html',
    styleUrls: ['./crm.component.scss'],
    standalone: false
})
export class CRMComponent implements OnInit {

  private readonly adminService = inject(AdminService);

  public readonly roleService = inject(RoleService);


  constructor() { }

  ngOnInit(): void {
    this.adminService.pageTitle.set(this.adminService.getText('crm'));
  }

}
